const SectionContent = {
  topSection: {
    en: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_reservation.jpg`,
      title: 'Chowbus Reservations',
      description: `Simplify table reservations and delight customers.`,
      youtubeVideoId: 'qwYRwVLsXLM',
    },
    zh: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_reservation.jpg`,
      title: '预约',
      description: '和POS系统打通的预约功能，覆盖多渠道',
      youtubeVideoId: 'IL1aXMU4Xo0',
    },
  },
  advances: {
    en: {
      title: `Reservations Made Simple for Guests & Restaurants`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_reservation_feature_1.png`,
          imageAlt: 'Seamless Reservation Experience',
          title: 'Seamless Reservation Experience',
          description: 'Customers can easily self reserve through Google Maps or your website.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_reservation_feature_2.png`,
          imageAlt: 'One View for Reservations, Waitlists, & Tables',
          title: 'One View for Reservations, Waitlists, & Tables',
          description: 'Restaurant staff can easily manage waitlists, reservations, and tables in one view.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_reservation_feature_3.png`,
          imageAlt: 'Save Time, Save Money',
          title: 'Save Time, Save Money',
          description: `Skip the manual notes and phone calls! Expedite your reservations to enhance customer satisfaction and repeat visits.`,
        },
      ],
    },
    zh: {
      title: `Chowbus预约功能便捷餐厅和顾客`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_reservation_feature_1.png`,
          imageAlt: '灵活的预约方式',
          title: '灵活的预约方式',
          description: '餐厅不仅能在POS App上帮助顾客预约，顾客还能在谷歌地图/餐厅网页上完成自助预约、管理预约流程。',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_reservation_feature_2.png`,
          imageAlt: '统一的管理入口',
          title: '统一的管理入口',
          description: '餐厅可以在POS App上管理所有的排队、预约信息及桌位信息，提前为顾客安排好桌位，优化桌位管理。',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_reservation_feature_3.png`,
          imageAlt: '高效的服务效率',
          title: '高效的服务效率',
          description:
            '餐厅无需花费更多时间在电话记录预约信息和人工管理预约信息；顾客在预约的时间到店并入座，加快了入座速度的同时提高顾客满意度。',
        },
      ],
    },
  },

  features: {
    en: {
      title: 'How Our Reservation System Works',
      items: [
        {
          layout: 'row',
          direction: 'reverse',
          title: 'Quick, Easy Mobile Reservations ',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_reservation_advance_1.png`,
          coverStyle: { padding: '20px 20px' },
          coverRatio: 392 / 459,
          items: [
            {
              desc: `Easily reserve a table through Google Maps or your website.`,
            },
            {
              desc: `Pick a time, number of seats, and book! A confirmation email will be sent to the customer right away.`,
            },
            {
              desc: `Restaurant staff can easily modify reservation information on-demand.`,
            },
          ],
        },
        {
          layout: 'row',
          direction: 'normal',
          title: 'Self-serve Reservation Setup',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_reservation_advance_2.png`,
          coverStyle: { padding: '20px 20px' },
          coverRatio: 370 / 446,
          items: [
            {
              desc: 'Easily configure your reservation settings in your Chowbus Dashboard.',
            },
            {
              desc: `Modify capacity, intervals, open/close times, and auto-notification settings!`,
            },
          ],
        },
        {
          layout: 'row',
          direction: 'reverse',
          title: 'Manage Reservations & Tables',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_reservation_advance_3.png`,
          coverStyle: { padding: '20px 20px' },
          coverRatio: 370 / 476,
          items: [
            {
              desc: 'Notify, confirm, reschedule, or cancel reservations in a few clicks within your POS dashboard.',
            },
            {
              desc: `Check-in customers and assign to tables with ease.`,
            },
          ],
        },
      ],
    },
    zh: {
      title: '如何使用Chowbus预约系统？',
      items: [
        {
          layout: 'row',
          direction: 'reverse',
          title: '顾客可以在谷歌地图或者餐厅订餐网页预约餐厅',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_reservation_advance_1.png`,
          coverStyle: { padding: '20px 20px' },
          coverRatio: 392 / 459,
          items: [
            {
              desc: `谷歌地图搜索餐厅/谷歌搜索餐厅网页.`,
            },
            {
              desc: `选择心仪的时间后填写预约信息：人数、日期`,
            },
            {
              desc: `如果行程有变动，自行修改预约时间`,
            },
          ],
        },
        {
          layout: 'row',
          direction: 'normal',
          title: '餐厅如何设置预约系统？',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_reservation_advance_2.png`,
          coverStyle: { padding: '20px 20px' },
          coverRatio: 370 / 446,
          description:
            '餐厅可以在Dashboard上设置：是否开启谷歌预约，可预约人数、可选时间间隔、支持的桌型、开放预约时间、可提前预约的时间范围、自动提醒客户用餐',
          // items: [
          //   {
          //     desc: '餐厅可以在Dashboard上设置：是否开启谷歌预约，可预约人数、可选时间间隔、支持的桌型、开放预约时间、可提前预约的时间范围、自动提醒客户用餐',
          //   },
          // ],
        },
        {
          layout: 'row',
          direction: 'reverse',
          title: '餐厅如何管理预约信息？',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_reservation_advance_3.png`,
          coverStyle: { padding: '20px 20px' },
          coverRatio: 370 / 476,
          // description:
          //   '餐厅可以在POS App上帮客户预约并管理预约信息：',
          items: [
            {
              desc: '针对尚未到店的顾客：提醒用餐、确认是否到店，改期、取消预约',
            },
            {
              desc: `针对即将到店的顾客：提前安排桌位`,
            },
            {
              desc: '针对到店的顾客：check in并安排桌位',
            },
          ],
        },
      ],
    },
  },

  customerVoiceInfos: [
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-machimachi.jpeg`,
      productLine: 'Loyalty',
      desc: {
        zh: `“自从我们在纽约中城开了第一家店之后，就一直使用Chowbus POS和他们的智能⾃助点餐机。之后我们还加入了餐厅专属会员系统。客人在智能⾃助点餐机上点完餐后，系统就会自动弹出弹窗，引导客人注册成餐厅会员。这个系统在智能⾃助点餐机的基础上，自动地将新顾客转化成忠实的回头客。用了一段时间后，我们的客单价提高了18%，餐厅利润提高了，用户关系也变得更加牢固了。我们对这个效果非常满意！”`,
        en: `“We’ve started using Chowbus POS Kiosk since we opened our first location in Midtown, New York. Later, we decided to add the Loyalty Program addition to the Kiosk. When new customers come to the store, they can directly order from the Kiosk, and the system will encourage them to sign up for the restaurant loyalty program. By leveraging the Kiosk and Loyalty Program together, the average order size increased 18%. Our customer relationships became even stronger and more profitable.”`,
      },
      restaurantName: { zh: 'Machi Machi', en: 'Machi Machi' },
      location: { zh: '纽约', en: 'New York, NY' },
      link: '/business-types/boba-tea-dessert/machi-machi',
    },
  ],
};

export default SectionContent;
